<script lang="ts">
	import ChevronRight from "svelte-radix/ChevronRight.svelte";
	import ChevronLeft from "svelte-radix/ChevronLeft.svelte";
	import DoubleArrowRight from "svelte-radix/DoubleArrowRight.svelte";
	import DoubleArrowLeft from "svelte-radix/DoubleArrowLeft.svelte";
	import type { TableViewModel } from "svelte-headless-table";
    import type { GroupStoreInfo } from "$src/domain/users/UserGroupStoreAccess";
    // import * as Select from "$lib/components/ui/select";
    import { Button } from "$lib/components/ui/button";
    import { t } from 'svelte-i18n'

	export let tableModel: TableViewModel<GroupStoreInfo>;

	const { pageRows, pluginStates, rows } = tableModel;

	const { hasNextPage, hasPreviousPage, pageIndex, pageCount, pageSize } = pluginStates.page;

</script>

<div class="flex items-center justify-end px-2 p-4">
	<div class="flex items-center space-x-6 lg:space-x-8">
		<!-- <div class="flex items-center space-x-2">
			<p class="text-sm font-medium">Rows per page</p>
			<Select.Root
				onSelectedChange={(selected) => pageSize.set(Number(selected?.value))}
				selected={{ value: 10, label: "10" }}
			>
				<Select.Trigger class="h-8 w-[70px]">
					<Select.Value placeholder="Select page size" />
				</Select.Trigger>
				<Select.Content>
					<Select.Item value="10">10</Select.Item>
					<Select.Item value="20">20</Select.Item>
					<Select.Item value="30">30</Select.Item>
					<Select.Item value="40">40</Select.Item>
					<Select.Item value="50">50</Select.Item>
				</Select.Content>
			</Select.Root>
		</div> -->
		<div class="flex w-[100px] items-center justify-center text-sm font-medium">
			{$t('global.messages.page')} {$pageIndex + 1} {$t('global.messages.pageof')}  {$pageCount}
		</div>
		<div class="flex items-center space-x-2">
			<Button
				variant="outline"
				class="hidden h-8 w-8 p-0 lg:flex"
				on:click={() => ($pageIndex = 0)}
				disabled={!$hasPreviousPage}
			>
				<span class="sr-only">Go to first page</span>
				<DoubleArrowLeft size={15} />
			</Button>
			<Button
				variant="outline"
				class="h-8 w-8 p-0"
				on:click={() => ($pageIndex = $pageIndex - 1)}
				disabled={!$hasPreviousPage}
			>
				<span class="sr-only">Go to previous page</span>
				<ChevronLeft size={15} />
			</Button>
			<Button
				variant="outline"
				class="h-8 w-8 p-0"
				disabled={!$hasNextPage}
				on:click={() => ($pageIndex = $pageIndex + 1)}
			>
				<span class="sr-only">Go to next page</span>
				<ChevronRight size={15} />
			</Button>
			<Button
				variant="outline"
				class="hidden h-8 w-8 p-0 lg:flex"
				disabled={!$hasNextPage}
				on:click={() => ($pageIndex = Math.ceil($rows.length / $pageRows.length) - 1)}
			>
				<span class="sr-only">Go to last page</span>
				<DoubleArrowRight size={15} />
			</Button>
		</div>
	</div>
</div>